import { useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
// import Footer from './Footer';
import Header from './Header';
import Sidebar from './Sidebar';
import HorizontalBar from './HorizontalBar';
import MainContentStyled from './MainContentStyled';
// import Customization from '../Customization';
import Loader from 'ui-component/Loader';
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';

import { MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import useGlobalSocketEvents from 'hooks/useGlobalSocketEvents';
import MainInnerContentStyled from './MainInnerContentStyled';
import LeftAppSidebar from './LeftAppSidebar';
import RightAppSidebar from './RightAppSidebar';
import { useSelector, dispatch } from 'store';
import { closeAllSidebars } from 'store/slices/dual-sidebar';
import { closeAppSidebar } from 'store/slices/app-sidebar';

// ==============================|| MAIN LAYOUT ||============================== //

export default function MainLayout() {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();

  //* global socket events handler
  useGlobalSocketEvents();

  const { borderRadius, container, miniDrawer, menuOrientation } = useConfig();
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;


  useEffect(() => {
    // handlerDrawerOpen(!miniDrawer);
    handlerDrawerOpen(false);
  }, [miniDrawer]);

  useEffect(() => {
    downMD && handlerDrawerOpen(false);
  }, [downMD]);

  // סגירת כל הסיידברים בעת מעבר בין מסכים
  useEffect(() => {
    dispatch(closeAllSidebars());
    closeAppSidebar();
  }, [location.pathname]);

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

  // horizontal menu-list bar : drawer
  const menu = useMemo(() => (isHorizontal ? <HorizontalBar /> : <Sidebar />), [isHorizontal]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex' }}>
      {/* header */}
      <AppBar
        enableColorOnDark
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{ bgcolor: 'background.default' }}
      >
        <Toolbar sx={{ p: isHorizontal ? 1.25 : 2 }}>
          <Header />
        </Toolbar>
      </AppBar>

      {/* menu / drawer */}
      {menu}

      {/* main content */}
      <MainContentStyled {...{ borderRadius, menuOrientation, open: drawerOpen }}>
        <Container
          maxWidth={container ? 'lg' : false}
          sx={{
            ...(!container && { px: { xs: 0 } }),
            height: 'calc(100vh - 128px)',
            // minHeight: 'calc(100vh - 128px)',
            maxHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          {/* breadcrumb */}
          {/* <Breadcrumbs sx={{ flexShrink: 0 }} /> */}
          <Box sx={{ flex: '1 1 auto', overflow: 'hidden' }}>
            <Box
              sx={{
                height: '100%',
                width: '100%',
                display: 'flex',
              }}
            >
              <LeftAppSidebar />
              <MainInnerContentStyled {...{ borderRadius }}>
                <Outlet />
              </MainInnerContentStyled>
              <RightAppSidebar />
            </Box>
          </Box>
          {/* <Footer /> */}
        </Container>
      </MainContentStyled>
      {/* <Customization /> */}
    </Box>
  );
}
